import { CheckCircleOutlined, PlayCircleOutlined } from '@ant-design/icons'

import { StatusColor } from '../../../../common/constants/color.constants'
import { PureButton } from '../../../../common/ui/pure-button/pure-button'
import { MilestoneChecklistStatus } from '../../../../entities/workflow/constants/workflow.constants'
import { startFillChecklistStatuses } from '../constants/workspace.constants'

type MilestoneStatusButtonProps = {
  status: MilestoneChecklistStatus
  isStarted: boolean
  statusChange: (status: MilestoneChecklistStatus) => void
  start: () => void
}

export const MilestoneStatusButton = ({ status, statusChange, isStarted, start }: MilestoneStatusButtonProps) => {
  if (startFillChecklistStatuses.includes(status)) {
    return (
      <div>
        <PureButton
          onClick={() => (isStarted ? statusChange(MilestoneChecklistStatus.InProgress) : start())}
          type="text"
        >
          <PlayCircleOutlined style={{ color: StatusColor.InProgress }} />
        </PureButton>
      </div>
    )
  }

  return (
    <div>
      {/*<PureButton*/}
      {/*  onClick={() => statusChange(MilestoneChecklistStatus.Paused)}*/}
      {/*  style={{ color: StatusColor.Paused }}*/}
      {/*  type="text"*/}
      {/*>*/}
      {/*  <PauseCircleOutlined />*/}
      {/*</PureButton>*/}
      <PureButton
        className="ml-1"
        onClick={() => statusChange(MilestoneChecklistStatus.Completed)}
        style={{ color: StatusColor.Completed }}
        type="text"
      >
        <CheckCircleOutlined />
      </PureButton>
    </div>
  )
}
